"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAllTertiaryForPrimary = exports.findAllSecondaryForPrimary = exports.findAllBlocksByType = exports.findTertiaryBlocksBySize = exports.findSecondaryBlocksBySize = exports.findBlockByPackageName = exports.findAllBlocks = void 0;
var packages_1 = require("../packages");
var types_1 = require("@kameleon-core/types");
function notEmpty(value) {
    return value !== null && value !== undefined;
}
/**
 * Find all Kameleon Elements (blocks/sections) as promises.
 */
function findAllBlocks() {
    return __awaiter(this, void 0, void 0, function () {
        var blocks;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    blocks = Object.values(packages_1.Packages).map(function (entry) { return __awaiter(_this, void 0, void 0, function () {
                        var element, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, entry()];
                                case 1:
                                    element = _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    console.log(e_1);
                                    return [2 /*return*/, null];
                                case 3:
                                    if (!("default" in element) || !(0, types_1.isKameleonElement)(element.default)) {
                                        return [2 /*return*/, null];
                                    }
                                    return [2 /*return*/, element.default];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(blocks)];
                case 1: return [2 /*return*/, (_a.sent()).filter(notEmpty)];
            }
        });
    });
}
exports.findAllBlocks = findAllBlocks;
/**
 * Find a block given a package name of the block
 * @param packageName
 */
function findBlockByPackageName(packageName) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var block;
        return __generator(this, function (_b) {
            // eslint-disable-next-line no-promise-executor-return
            if (!packageName)
                return [2 /*return*/, new Promise(function (r) { return r(null); })];
            block = (_a = packages_1.Packages === null || packages_1.Packages === void 0 ? void 0 : packages_1.Packages[packageName]) !== null && _a !== void 0 ? _a : null;
            // eslint-disable-next-line no-promise-executor-return
            if (!block)
                return [2 /*return*/, new Promise(function (r) { return r(null); })];
            return [2 /*return*/, block().then(function (element) {
                    if (!("default" in element) || !(0, types_1.isKameleonElement)(element.default)) {
                        return null;
                    }
                    return element.default;
                })];
        });
    });
}
exports.findBlockByPackageName = findBlockByPackageName;
function findSecondaryBlocksBySize(blockSize) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findAllBlocks()];
                case 1: return [2 /*return*/, (_a.sent()).filter(function (element) {
                        var _a, _b, _c;
                        return (element === null || element === void 0 ? void 0 : element.component) &&
                            element.component.blockType === types_1.BlockType.Secondary &&
                            !(0, types_1.isPrimaryBlock)(element.component) &&
                            (Array.isArray((_a = element.component) === null || _a === void 0 ? void 0 : _a.blockSize)
                                ? ((_b = element.component) === null || _b === void 0 ? void 0 : _b.blockSize).includes(blockSize)
                                : ((_c = element.component) === null || _c === void 0 ? void 0 : _c.blockSize) === blockSize);
                    })];
            }
        });
    });
}
exports.findSecondaryBlocksBySize = findSecondaryBlocksBySize;
function findTertiaryBlocksBySize(blockSize) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findAllBlocks()];
                case 1: return [2 /*return*/, (_a.sent()).filter(function (element) {
                        var _a, _b;
                        return element.component &&
                            element.component.blockType === types_1.BlockType.Tertiary &&
                            !(0, types_1.isPrimaryBlock)(element.component) &&
                            (Array.isArray(element.component.blockSize)
                                ? ((_a = element.component) === null || _a === void 0 ? void 0 : _a.blockSize).includes(blockSize)
                                : ((_b = element.component) === null || _b === void 0 ? void 0 : _b.blockSize) === blockSize);
                    })];
            }
        });
    });
}
exports.findTertiaryBlocksBySize = findTertiaryBlocksBySize;
function findAllBlocksByType(blockType) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findAllBlocks()];
                case 1: return [2 /*return*/, (_a.sent()).filter(function (element) { return element.component.blockType === blockType; })];
            }
        });
    });
}
exports.findAllBlocksByType = findAllBlocksByType;
function findAllSecondaryForPrimary(primaryBlockElement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, findSecondaryBlocksBySize(primaryBlockElement.secondaryBlockSize)];
        });
    });
}
exports.findAllSecondaryForPrimary = findAllSecondaryForPrimary;
function findAllTertiaryForPrimary(primaryBlockElement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, findTertiaryBlocksBySize(primaryBlockElement.tertiaryBlockSize)];
        });
    });
}
exports.findAllTertiaryForPrimary = findAllTertiaryForPrimary;
